import omit from 'lodash/omit';
import { IjobHour } from '../models';

export type StagedJobHours = { [id: string]: IjobHour };

/** Add or replace a staged job hour, keyed by its id. Returns a new map. */
export const addStagedHour = (staged: StagedJobHours, jobHour: IjobHour): StagedJobHours => ({
    ...staged,
    [jobHour.id]: jobHour
});

/** Remove a staged job hour by id. Returns a new map. */
export const removeStagedHour = (staged: StagedJobHours, id: string): StagedJobHours => omit(staged, [id]);
